﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";


export class GuiDetailBenutzerAnfallstelle extends GuiDetailGeneric {

    constructor() {
        super("GuiDetailBenutzerAnfallstelle");
        this.adjustAnfallstellen();
    }

    override attachEvents(): void {
        super.attachEvents();

        $("#VmDetail_StandortId").on("change", () => this.changeStandort());
    }

    changeStandort() {
        this.log("changeStandort");
        $("#VmDetail_AnfallstelleId").val("alle");
        this.adjustAnfallstellen();
    }

    adjustAnfallstellen() {
        this.log("adjustAnfallstellen");

        const standortId = $("#VmDetail_StandortId").val() as string;

        this.log(`standortId=${standortId}`);

        if (standortId !== "") {
            const options = $("#VmDetail_AnfallstelleId option");
            options.each((_index, element) => {
                const option = $(element);
                if (option.data("data1") !== standortId) {
                    option.hide();
                } else {
                    option.show();
                }
                if (option.val() === "alle") {
                    option.show();
                }
            });
        }

        const x = $("#VmDetail_AnfallstelleId option[data-data1='" + standortId + "']");
        this.log(`${x.length}`);
        if (x.length === 0) {
            $("#VmDetail_AnfallstelleId").attr("disabled", "disabled");
        } else {
            $("#VmDetail_AnfallstelleId").removeAttr("disabled");
        }


    }


}
